/**
 * useRitual Hook
 * Fetches ritual details by ID using React Query
 */

import { useQuery } from "@tanstack/react-query"
import { getRitualById } from "../services/ritual.service"

interface UseRitualOptions {
  enabled?: boolean
}

export function useRitual(ritualId: string, options?: UseRitualOptions) {
  return useQuery({
    queryKey: ["ritual", ritualId],
    queryFn: () => getRitualById(ritualId),
    enabled: options?.enabled ?? !!ritualId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
